import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const PeopleOneOutlineIcon: SVGFC = ({ color = tailwindColors.secondary.DEFAULT, ...props }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.3993 17.4146C15.3993 15.9019 14.7813 14.4512 13.681 13.3815C12.5808 12.3119 11.0886 11.7109 9.53268 11.7109C7.97674 11.7109 6.48454 12.3119 5.38432 13.3815C4.28411 14.4512 3.66602 15.9019 3.66602 17.4146"
        stroke={color}
        strokeWidth="1.28333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.53385 11.7117C11.5589 11.7117 13.2005 10.1156 13.2005 8.14685C13.2005 6.17805 11.5589 4.58203 9.53385 4.58203C7.50881 4.58203 5.86719 6.17805 5.86719 8.14685C5.86719 10.1156 7.50881 11.7117 9.53385 11.7117Z"
        stroke={color}
        strokeWidth="1.28333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3336 16.7033C18.3336 14.3006 16.867 12.0691 15.4003 10.9996C15.8824 10.648 16.2679 10.1862 16.5227 9.65517C16.7775 9.12414 16.8938 8.54024 16.8611 7.95513C16.8285 7.37002 16.648 6.80176 16.3357 6.30063C16.0233 5.7995 15.5887 5.38095 15.0703 5.08203"
        stroke={color}
        strokeWidth="1.28333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PeopleOneOutlineIcon
